import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DrrCcdDeviceApplicationDto } from './technical-data/technical-data.domain';
import { StoreItem } from 'src/app/+shared/stores/StoreItem';

@Injectable({
  providedIn: 'root',
})
export class DrrCcdDataStore {
  constructor() {}

  private _applicationDto: StoreItem<DrrCcdDeviceApplicationDto> = new StoreItem<DrrCcdDeviceApplicationDto>(null);

  public setApplicationDto(value: DrrCcdDeviceApplicationDto) {
    this._applicationDto.setValue(value);
  }

  public getApplicationDto(): Observable<DrrCcdDeviceApplicationDto> {
    return this._applicationDto.getObservable();
  }
}
